module.exports = __webpack_public_path__ + "img/more2.8adadc97.svg";